<template>
  <MarketCarpetParentBox
    v-if="!isLeafBoxData(node.data)"
    :width="width"
    :height="height"
    :data="node.data"
    :depth="node.depth"
  />
  <MarketCarpetLeafBox
    v-else
    :width="width"
    :height="height"
    :data="node.data"
    :parent="node.parent"
  />
</template>

<script lang="ts" setup>
  import { computed, toRefs } from 'vue';
  import MarketCarpetParentBox from '@/components/MarketCarpetParentBox.vue';
  import MarketCarpetLeafBox from '@/components/MarketCarpetLeafBox.vue';
  import type { LeafNode, ParentNode } from '@/ts/composables/useMarketCarpetData';
  import type { Box } from '@/ts/composables/useHoverBox';

  function isLeafBoxData(data: ParentNode | LeafNode): data is LeafNode {
    return 'symbol' in data;
  }

  const props = defineProps<{
    node: Box;
  }>();

  const { node } = toRefs(props);

  const width = computed(() => {
    return node.value.x1 - node.value.x0;
  });

  const height = computed(() => {
    return node.value.y1 - node.value.y0;
  });
</script>

<style scoped>
  text {
    user-select: none;
  }
</style>
